import { render } from "./BecomePartner.vue?vue&type=template&id=18813e3a&scoped=true"
import script from "./BecomePartner.vue?vue&type=script&lang=js"
export * from "./BecomePartner.vue?vue&type=script&lang=js"

import "./BecomePartner.vue?vue&type=style&index=0&id=18813e3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18813e3a"]])

export default __exports__